var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEditIconGray({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M13.7589 2.894L11.1047 0.23982C11.0525 0.187503 10.9903 0.146096 10.9219 0.118004C10.8535 0.0899123 10.7802 0.075697 10.7063 0.076184H10.6883C10.5273 0.0819509 10.3745 0.148966 10.2612 0.263547L1.46329 9.06309C1.40924 9.11722 1.36934 9.18382 1.3471 9.257L0.0682857 13.5451C0.0159221 13.7185 0.280195 13.9362 0.429104 13.9362C0.438631 13.937 0.448213 13.937 0.45774 13.9362C0.584558 13.9067 4.07983 12.857 4.74501 12.6565C4.81711 12.6349 4.88265 12.5955 4.93565 12.542L13.7344 3.73755C13.8443 3.62855 13.9104 3.48297 13.9201 3.32846C13.9255 3.24876 13.9139 3.16882 13.8861 3.09393C13.8584 3.01904 13.815 2.95089 13.7589 2.894ZM1.27265 12.731L2.19719 9.63173L4.37029 11.7999C3.37456 12.0985 2.13092 12.4741 1.27265 12.731Z",
    fill: "#909090"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEditIconGray);
export default __webpack_public_path__ + "static/media/edit-icon-gray.8d4ef9e882cfa7f1d3b6edaeba93dad6.svg";
export { ForwardRef as ReactComponent };